<template>
  <datepicker
    v-model="month"
    format="MM/yyyy"
    class="form_fix"
    :minimumView="'month'"
    :maximumView="'month'"
    :language="vi"
    :placeholder="placeholder"
    :clearButton="true"
  ></datepicker>
</template>

<script>
  import moment from 'moment'
  import { vi } from 'vuejs-datepicker/dist/locale'

  export default {
    props: ['value', 'placeholder'],
    data() {
      return {
        month: null,
        vi,
      }
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            const d = val.split('/')
            const date = new Date(d[1] + '/' + d[0] + '/' + '01')
            this.month = date
          } else {
            this.month = null
          }
        },
        immediate: true,
      },
      month: {
        handler(val) {
          // console.log(22, val)
          if (val) {
            const timeString = moment(val).format('MM/YYYY')
            this.$emit('input', timeString)
          } else {
            this.$emit('input', null)
          }
        },
        deep: true,
      },
    },
    methods: {},
  }
</script>

<style>
  .form_fix input {
    border-radius: 4px;
    border-color: #ced4da;
  }
  .form_fix input::placeholder {
    color: #999999 !important;
  }
</style>
